/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatAgentAddRequest
 */
export interface ChatAgentAddRequest {
    /**
     * The name of the user to invite
     * @type {string}
     * @memberof ChatAgentAddRequest
     */
    name: string;
    /**
     * An (optional) URL to an avatar for this user
     * @type {string}
     * @memberof ChatAgentAddRequest
     */
    avatarUrl?: string;
    /**
     * List of domain IDs this agent should have permissions for
     * @type {Array<string>}
     * @memberof ChatAgentAddRequest
     */
    domains: Array<string>;
    /**
     * List of domain IDs for which this agent should be the default assignee
     * @type {Array<string>}
     * @memberof ChatAgentAddRequest
     */
    defaultAssignee: Array<string>;
    /**
     * List of domain IDs for which this agent should receive email notifications
     * @type {Array<string>}
     * @memberof ChatAgentAddRequest
     */
    emailNotification: Array<string>;
}

/**
 * Check if a given object implements the ChatAgentAddRequest interface.
 */
export function instanceOfChatAgentAddRequest(value: object): value is ChatAgentAddRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('domains' in value) || value['domains'] === undefined) return false;
    if (!('defaultAssignee' in value) || value['defaultAssignee'] === undefined) return false;
    if (!('emailNotification' in value) || value['emailNotification'] === undefined) return false;
    return true;
}

export function ChatAgentAddRequestFromJSON(json: any): ChatAgentAddRequest {
    return ChatAgentAddRequestFromJSONTyped(json, false);
}

export function ChatAgentAddRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatAgentAddRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'domains': json['domains'],
        'defaultAssignee': json['defaultAssignee'],
        'emailNotification': json['emailNotification'],
    };
}

export function ChatAgentAddRequestToJSON(json: any): ChatAgentAddRequest {
    return ChatAgentAddRequestToJSONTyped(json, false);
}

export function ChatAgentAddRequestToJSONTyped(value?: ChatAgentAddRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'avatarUrl': value['avatarUrl'],
        'domains': value['domains'],
        'defaultAssignee': value['defaultAssignee'],
        'emailNotification': value['emailNotification'],
    };
}

